import React from 'react';
import { Button, Drawer, List, Skeleton } from 'antd';
import PropTypes from 'prop-types';
import "./index.css";
import AntDropdown from '../components/CustomDropdown/AntDropdown';
import { hideLoader, showLoader } from '../utils/loader';
import { customBaseUrl, httpPut } from '../store/http';
import Swal from 'sweetalert2';

const Notification = ({
  open,
  getNotification,
  setOpen,
  notifications,
  totalNotifications,
  handleDelete,
  pagination,
  handleLoadMore
}) => {
  const onClose = () => {
    setOpen(false);
  };

  const loadMore = (
    <div
      style={{
        textAlign: 'center',
        marginTop: 12,
        height: 32,
        lineHeight: '32px',
      }}
    >
      {pagination.current > 0 && <Button onClick={() => handleLoadMore('back')}>Prev</Button>}
      {pagination.current < Math.floor(totalNotifications / pagination.pageSize) && (
        <Button onClick={() => handleLoadMore('next')}>Next</Button>
      )}
    </div>
  );

  const handleRead = async (id) => {
    let data = { "read": true };
    showLoader();
    try {
      let res = await httpPut(`${customBaseUrl.notificationUrl}/in-app-notifications/${localStorage.getItem('userId')}/${id}`, data);
      hideLoader();
      if (res.status) {
        Swal.fire('Done', res.message);
        await getNotification(pagination.current, pagination.pageSize);
      } else {
        Swal.fire('Error', res.message);
      }
    } catch (error) {
      hideLoader();
      Swal.fire('Error', 'Something went wrong');
    }
  };

  const handleUnRead = async (id) => {
    let data = { "read": false };
    showLoader();
    try {
      let res = await httpPut(`${customBaseUrl.notificationUrl}/in-app-notifications/${localStorage.getItem('userId')}/${id}`, data);
      hideLoader();
      if (res.status) {
        Swal.fire('Done', res.message);
        await getNotification(pagination.current, pagination.pageSize);
      } else {
        Swal.fire('Error', res.message);
      }
    } catch (error) {
      hideLoader();
      Swal.fire('Error', 'Something went wrong');
    }
  };

  const notAction = (action, id) => {
    if (action === 'Mark as read') handleRead(id);
    if (action === 'Mark as unread') handleUnRead(id);
    if (action === 'Delete') handleDelete(id);
  };

  return (
    <Drawer
      title="Notifications"
      placement="right"
      closable={true}
      onClose={onClose}
      visible={open}
      width={400}
    >
      <List
        className="demo-loadmore-list"
        itemLayout="horizontal"
        loadMore={loadMore}
        dataSource={notifications}
        renderItem={(item) => (
          <List.Item
            actions={[
              <AntDropdown 
                dropDownOptions={[item?.read ? 'Mark as unread' : 'Mark as read', 'Delete']} 
                handleDropdownAction={(action) => notAction(action, item.notificationId)}
              />
            ]}
          >
            <Skeleton avatar title={false} loading={item.loading} active>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div style={{ color: item?.read ? 'var(--text-muted)' : 'var(--text-main)', fontSize: '14px' }}>
                  {item.content}
                </div>
              </div>
            </Skeleton>
          </List.Item>
        )}
      />
    </Drawer>
  );
};

Notification.propTypes = {
  open: PropTypes.bool.isRequired,
  getNotification: PropTypes.func.isRequired,
  setOpen: PropTypes.func.isRequired,
  notifications: PropTypes.array.isRequired,
  totalNotifications: PropTypes.number.isRequired,
  handleDelete: PropTypes.func.isRequired,
  pagination: PropTypes.object.isRequired,
  handleLoadMore: PropTypes.func.isRequired,
};

export default Notification;